import { DateRangeFilter } from '@/components/filters/DateRangeFilter';
import { PayoutBatchStatusFilter } from '@/components/filters/PayoutBatchStatusFilter';
import { FilterGroup } from '@/components/filters/filter-button';
import type { PayoutBatchesFilters as PayoutBatchesQueryFilters } from '@/hooks/queries/use-payout-batches-query';
import { HStack } from '@chakra-ui/react';
import type { PayoutBatchStatus } from '@fluenceur/types';
import { parseAsString, useQueryState } from 'nuqs';
import React, { useEffect } from 'react';
import { PAYOUT_STATUS_PARAM, payoutStatusParser } from './payouts-tab-url';

interface PayoutBatchesFiltersProps {
  onFiltersChange: (filters: PayoutBatchesQueryFilters) => void;
  initialFilters?: Partial<PayoutBatchesQueryFilters>;
}

export const PayoutBatchesFilters: React.FC<PayoutBatchesFiltersProps> = ({
  onFiltersChange,
  initialFilters = {},
}) => {
  // Read from the address like the dates, so a link can open the list already
  // narrowed to one status (the unfinished payouts notice sends drafts here).
  const [status, setStatus] = useQueryState(PAYOUT_STATUS_PARAM, payoutStatusParser);

  // Use useQueryState to read the date values from URL
  const [urlStartDate] = useQueryState('startDate', parseAsString);
  const [urlEndDate] = useQueryState('endDate', parseAsString);

  useEffect(() => {
    const activeFilters: PayoutBatchesQueryFilters = {};
    if (status !== null) activeFilters.status = status;
    if (urlStartDate) activeFilters.startDate = urlStartDate;
    if (urlEndDate) activeFilters.endDate = urlEndDate;

    onFiltersChange(activeFilters);
  }, [status, urlStartDate, urlEndDate, onFiltersChange]);

  const handleStatusChange = (newStatus: PayoutBatchStatus | null) => {
    setStatus(newStatus);
  };

  return (
    <FilterGroup>
      <HStack gap={3} alignItems="flex-start">
        <PayoutBatchStatusFilter
          label="Status"
          value={status}
          onChange={handleStatusChange}
          initialValue={initialFilters.status || null}
        />

        <DateRangeFilter />
      </HStack>
    </FilterGroup>
  );
};
